import React, { FC, ReactNode } from "react";
import {
  Table as MuiTable,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";

import styles from "./CalendarTable.module.scss";

type ColumnMonth = {
  id: string;
  label: string;
  month: number;
};

type ColumnDate = Omit<ColumnMonth, "month"> & {
  date: number;
};

interface CalendarTableProps {
  monthColumns?: ColumnMonth[];
  dateColumns: ColumnDate[];
  data?: { [key: string]: any }[];
  isYearCalendar: boolean;
  onItemClick?: (id: string) => void;
  renderCellMonth: (
    row: any,
    column: any,
    onItemClick?: (id: string) => void,
  ) => ReactNode;
  renderCellDate: (
    row: any,
    column: any,
    onItemClick?: (id: string) => void,
  ) => ReactNode;
}

const CalendarTable: FC<CalendarTableProps> = ({
  data,
  monthColumns,
  dateColumns,
  isYearCalendar,
  onItemClick,
  renderCellMonth,
  renderCellDate,
}) => {
  return (
    <div className={styles.tableContainer}>
      <MuiTable className={styles.table}>
        <TableHead className={styles.table__head} style={{ width: "100%" }}>
          <TableRow className={styles.table__head__row}>
            {((isYearCalendar && monthColumns) || dateColumns).map((column) => {
              return (
                <TableCell
                  className={styles.table__head__row__cell}
                  key={column.label}
                >
                  {column.label}
                </TableCell>
              );
            })}
          </TableRow>
        </TableHead>
        <TableBody className={styles.table__body}>
          {data?.map((row: any) => (
            <TableRow
              className={styles.table__body__row}
              sx={{ marginTop: "5px" }}
              key={row.id}
            >
              {((isYearCalendar && monthColumns) || dateColumns).map(
                (column: ColumnDate | ColumnMonth) => {
                  return (
                    <TableCell
                      className={styles.table__body__row__cell}
                      key={column.id}
                    >
                      {column.id === "title" ? (
                        <div className={styles.table__body__row__cell__title}>
                          {row?.vehicle_name || "---"}
                        </div>
                      ) : isYearCalendar ? (
                        renderCellMonth(row, column, onItemClick)
                      ) : (
                        renderCellDate(row, column, onItemClick)
                      )}
                    </TableCell>
                  );
                },
              )}
            </TableRow>
          ))}
        </TableBody>
      </MuiTable>
    </div>
  );
};

export default CalendarTable;
